module.exports = __webpack_public_path__ + "img/AVAX.7a39b4e3.svg";